"use client";

import { Building2, House as Home, Receipt } from 'lucide-react';
import { motion, useReducedMotion } from "framer-motion";
import { Link } from "@/components/common/Link";
export default function Contact() {
  const reduce = useReducedMotion();
  const lines = [{
    icon: Home,
    label: "RESIDENTIAL",
    desc: "Home cleaning, deep cleans, and recurring service.",
    phone: "(330) 203-1488",
    phoneHref: "tel:+13302031488",
    email: "info@summitcleanersohio.com",
    hours: "Mon-Sat, 8am-6pm"
  }, {
    icon: Building2,
    label: "COMMERCIAL",
    desc: "Office maintenance, retail, and facility care.",
    phone: "(330) 203-1488",
    phoneHref: "tel:+13302031488",
    email: "info@summitcleanersohio.com",
    hours: "Mon-Fri, 7am-7pm | Walkthroughs"
  }, {
    icon: Receipt,
    label: "POST-CONSTRUCTION",
    desc: "Dust removal, debris clearing, final polish.",
    phone: "(330) 203-1488",
    phoneHref: "tel:+13302031488",
    email: "info@summitcleanersohio.com",
    hours: "Mon-Fri, 8am-5pm | By Request"
  }];
  const headerVariants = {
    hidden: {
      opacity: 0,
      y: reduce ? 0 : 16
    },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.52,
        ease: [0.2, 0.6, 0.2, 1] as const
      }
    }
  };
  const containerVariants = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: reduce ? 0 : 0.09,
        delayChildren: 0.1
      }
    }
  };
  const cardsContainer = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: reduce ? 0 : 0.1,
        delayChildren: 0.3
      }
    }
  };
  const cardVariants = {
    hidden: {
      opacity: 0,
      y: reduce ? 0 : 16
    },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.48,
        ease: [0.2, 0.6, 0.2, 1] as const
      }
    }
  };
  return <section data-section-id="32627" id="basecamphoursandlocation" data-nav="light" className="relative border-t border-border bg-background text-foreground" style={{
    paddingTop: "clamp(5rem, 9vw, 9rem)",
    paddingBottom: "clamp(5rem, 9vw, 9rem)"
  }}>
      <div className="mx-auto w-full" style={{
      maxWidth: "1360px",
      paddingLeft: "clamp(1.25rem, 4vw, 3rem)",
      paddingRight: "clamp(1.25rem, 4vw, 3rem)"
    }}>
        {}
        <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
        once: true,
        amount: 0.3
      }} className="mx-auto flex flex-col items-center text-center" style={{
        marginBottom: "clamp(3rem, 5vw, 4rem)"
      }}>
          <motion.div variants={headerVariants} className="flex items-center gap-3">
            <span aria-hidden="true" className="inline-block" style={{
            width: "1.5px",
            height: "12px",
            backgroundColor: "var(--primary)"
          }} />
            <span className="font-default font-semibold uppercase" style={{
            fontSize: "0.75rem",
            letterSpacing: "0.22em",
            lineHeight: 1,
            color: "var(--primary)"
          }}>
              {"Contact Us"}
            </span>
            <span aria-hidden="true" className="inline-block" style={{
            width: "1.5px",
            height: "12px",
            backgroundColor: "var(--primary)"
          }} />
          </motion.div>

          <motion.h2 variants={headerVariants} className="mt-6 font-default font-bold uppercase text-foreground" style={{
          fontSize: "clamp(2.25rem, 5vw, 4.5rem)",
          letterSpacing: "-0.005em",
          lineHeight: 0.98,
          maxWidth: "22ch",
          fontStretch: "condensed"
        }}>
            {"Reach our team."}
            <br />
            {"We are ready."}
          </motion.h2>
        </motion.div>

        {}
        <motion.div variants={cardsContainer} initial="hidden" whileInView="show" viewport={{
        once: true,
        amount: 0.2
      }} className="grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-6">
          {lines.map((line, i) => {
          const Icon = line.icon;
          return <motion.div key={line.label} data-index={i} variants={cardVariants} whileHover={reduce ? undefined : {
            y: -2
          }} transition={{
            duration: 0.24,
            ease: [0.2, 0.6, 0.2, 1] as const
          } as any} className="group flex flex-col rounded-lg border border-border bg-card text-left" style={{
            padding: "clamp(2rem, 3.5vw, 3rem)"
          }}>
                {}
                <div className="flex items-center justify-center rounded-md border border-border transition-colors duration-200 group-hover:border-primary" style={{
              width: "40px",
              height: "40px"
            }}>
                  <Icon className="size-5" style={{
                color: "var(--primary)"
              }} strokeWidth={1.5} />
                </div>

                {}
                <h3 className="mt-6 font-default font-bold uppercase text-foreground" style={{
              fontSize: "clamp(1.25rem, 1.6vw, 1.5rem)",
              letterSpacing: "0.02em",
              lineHeight: 1.1
            }}>
                  {line.label}
                </h3>

                {}
                <p className="mt-2 font-default text-muted-foreground" style={{
              fontSize: "1rem",
              lineHeight: 1.65
            }}>
                  {line.desc}
                </p>

                {}
                <Link to={line.phoneHref} className="mt-6 inline-block font-default font-bold text-foreground transition-colors duration-200 hover:text-primary" style={{
              fontSize: "2.25rem",
              lineHeight: 1,
              letterSpacing: "-0.005em"
            }}>
                  {line.phone}
                </Link>

                {}
                <Link to={`mailto:${line.email}`} className="mt-2 font-mono text-muted-foreground transition-colors duration-200 hover:text-foreground" style={{
              fontSize: "0.9375rem",
              fontWeight: 500
            }}>
                  {line.email}
                </Link>

                {}
                <div className="mt-6 h-px w-full bg-border" aria-hidden="true" />

                {}
                <p className="mt-6 font-default text-muted-foreground" style={{
              fontSize: "0.8125rem",
              letterSpacing: "0.02em",
              lineHeight: 1.4,
              fontWeight: 500
            }}>
                  {line.hours}
                </p>
              </motion.div>;
        })}
        </motion.div>
      </div>
    </section>;
}